export default "__VITE_ASSET__2w4mLiV1__"